import { createReducer } from "../../common/reduxUtil";
import {
  PROGRAM_TO_UPDATE,
  SHORTLIST_CANDIDATE,
  SHOW_PROGRAM_UPDATE_MODAL,
} from "./types";

const initialState = {
  shortListUser: null,
  programToUpdate: null,
  showProgramUpdateModal: false,
};

export default createReducer(initialState, {
  [SHORTLIST_CANDIDATE]: (state, payload) => {
    return Object.assign({}, state, {
      shortListUser: payload,
    });
  },
  [PROGRAM_TO_UPDATE]: (state, payload) => {
    return Object.assign({}, state, {
      programToUpdate: payload,
    });
  },
  [SHOW_PROGRAM_UPDATE_MODAL]: (state, payload) => {
    return Object.assign({}, state, {
      showProgramUpdateModal: payload,
    });
  },
});
